<div class="breadcrumb-bar-container">
  <div class="row hide-for-small-only hide-for-print breadcrumb-bar">
    <div>
      <div class="small-12 columns no-padding">
        <ul class="breadcrumbs no-margin">
          <li *ngFor="let breadcrumb of breadcrumbs; trackBy: trackByBreadcrumb">
            <a [routerLink]="breadcrumb.url"><span>{{ breadcrumb.label }}</span></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>